import { Box, Icon, type IconProps } from "@chakra-ui/react";
import React from "react";

export function StripeMonoIcon(props: IconProps) {
  return (
    <Icon viewBox="0 0 21 21" {...props}>
      <Box
        as="path"
        fill="currentColor"
        fillRule="evenodd"
        d="M4.667 0A4.667 4.667 0 0 0 0 4.667v11.666A4.667 4.667 0 0 0 4.667 21h11.666A4.667 4.667 0 0 0 21 16.333V4.667A4.667 4.667 0 0 0 16.333 0H4.667Zm6.059 7.38c-.68 0-1.101.198-1.101.707H9.62c.001.558.718.803 1.605 1.106 1.447.494 3.347 1.143 3.347 3.556 0 2.346-1.857 3.513-4.549 3.513a8.885 8.885 0 0 1-3.542-.739v-2.938c1.09.592 2.474 1.039 3.546 1.039.723 0 1.242-.194 1.242-.798 0-.616-.772-.896-1.705-1.235-1.423-.515-3.217-1.166-3.217-3.347 0-2.309 1.75-3.692 4.381-3.692 1.072 0 2.144.164 3.22.596v3.07c-.985-.534-2.239-.837-3.223-.837Z"
        clipRule="evenodd"
      />
    </Icon>
  );
}
